//import liraries
import React  from 'react';
import { NavLink, useLocation } from 'react-router-dom';
 
// create a component
const OrderSideBar = () => {
    const location = useLocation();
    return (
      <div
        className={`menu-item has-sub ${
          location.pathname.startsWith("/Order")
            ? "active"
            : ""
        }`}
      >
        <div className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-utensils"></i>
          </div>
          <div className="menu-text">Orders</div>
          <div className="menu-caret"></div>
        </div>
        <div className="menu-submenu">

          <div
            className={`menu-item ${
              location.pathname.startsWith("/Order") ? "active" : ""
            }`}
          >
            <NavLink to="/Order/manageOrder" className="menu-link">
              Orders
            </NavLink>
          </div>
        </div>
      </div>
    );
};

 

//make this component available to the app
export default OrderSideBar;
